import { render, staticRenderFns } from "./addLooseOrder.vue?vue&type=template&id=4ea812a0&scoped=true&"
import script from "./addLooseOrder.vue?vue&type=script&lang=js&"
export * from "./addLooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./addLooseOrder.vue?vue&type=style&index=0&id=4ea812a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea812a0",
  null
  
)

export default component.exports